var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_123_13720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1338 54.4434V62.0002C43.1338 69.548 49.2526 75.6668 56.8005 75.6668H59.2123C64.3693 75.6668 68.7164 72.1982 70.0476 67.4668",
    stroke: "#45728B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3714 23.7334H33.1209C32.2657 23.7334 31.8381 23.7334 31.4777 23.7653C27.5195 24.1153 24.3819 27.2529 24.0319 31.2111C24 31.5715 24 31.9991 24 32.8542V35.3098C24 45.8768 32.5663 54.4431 43.1333 54.4431C53.2691 54.4431 61.4858 46.2264 61.4858 36.0907V32.8542C61.4858 31.9991 61.4858 31.5715 61.4538 31.2111C61.1039 27.2529 57.9663 24.1153 54.0079 23.7653C53.6477 23.7334 53.2199 23.7334 52.3649 23.7334H52.1142",
    stroke: "#45728B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4666 67.4663C74.9953 67.4663 78.6666 63.7951 78.6666 59.2664C78.6666 54.7377 74.9953 51.0664 70.4666 51.0664C65.9379 51.0664 62.2666 54.7377 62.2666 59.2664C62.2666 63.7951 65.9379 67.4663 70.4666 67.4663Z",
    stroke: "#45728B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.333 21V26.4666",
    stroke: "#45728B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9336 21V26.4666",
    stroke: "#45728B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_123_13720",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0 0.545098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_123_13720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_123_13720",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.5ff6aea019ba8440a6778ea4942ba039.svg";
export { ForwardRef as ReactComponent };